export enum EUnsplashForm {
  SEARCH = 'SEARCH',
}
